(() => {
  const mobileViewport = window.matchMedia('(max-width: 767px)');

  const positionBundles = () => {
    document.querySelectorAll('.section-main-product product-form.js-product').forEach((productForm) => {
      const gallery = productForm.querySelector('media-gallery.product-column-left');
      const bundles = productForm.querySelector('.csg-gallery-fbt');
      const callouts = productForm.querySelector('.product-column-right .product-form .csg-product-callouts');
      const calloutBlock = callouts?.closest('.lightly-spaced-row');

      if (!gallery || !bundles) return;

      if (mobileViewport.matches && calloutBlock) {
        if (bundles.previousElementSibling !== calloutBlock) {
          calloutBlock.insertAdjacentElement('afterend', bundles);
        }
      } else if (bundles.parentElement !== gallery) {
        gallery.appendChild(bundles);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionBundles, { once: true });
  } else {
    positionBundles();
  }

  mobileViewport.addEventListener('change', positionBundles);
  document.addEventListener('shopify:section:load', positionBundles);
  document.addEventListener('on:variant:change', positionBundles);
})();
